import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { LANDING_NEW_NAV_CTA_LEFT_CONTROL_HEIGHT } from '../../../src/landing/constants/landingNewNavCta.constants'

export function getLandingNavLinksStyles(theme: Theme) {
  return StyleSheet.create({
  navLinksRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    flex: 1,
  },
  navLinksRowCompact: {
    minWidth: 0,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  navLink: {
    height: LANDING_NEW_NAV_CTA_LEFT_CONTROL_HEIGHT,
    paddingHorizontal: 14,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  navLinkHovered: {
    backgroundColor: theme.background.primary,
    borderColor: theme.gray[300],
  },
  navLinkText: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 14.5,
    fontWeight: '500',
    color: theme.gray[800],
  },
  navLinkTextHovered: {
    color: theme.primaryLight,
  },
  orgMenuWrap: {
    position: 'relative',
    zIndex: 60,
  },
  orgMenuWrapCompact: {
    width: 'auto' as unknown as number,
  },
  orgTrigger: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  orgDropdown: {
    position: Platform.OS === 'web' ? ('absolute' as 'relative') : 'relative',
    top: 0,
    left: -48,
    width: 330,
    paddingTop: 42,
  },
  orgDropdownHoverPad: {
    width: '100%',
  },
  orgDropdownInner: {
    backgroundColor: theme.background.card,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: theme.gray[300],
    padding: 8,
    shadowColor: theme.primaryDark,
    shadowOffset: { width: 0, height: 18 },
    shadowOpacity: 0.16,
    shadowRadius: 34,
    elevation: 12,
  },
  orgDropdownCompact: {
    position: 'relative',
    top: 8,
    left: 0,
    width: '100%',
    paddingTop: 0,
    marginBottom: 8,
    shadowOpacity: 0.08,
    shadowRadius: 18,
  },
  orgDropdownItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingVertical: 12,
    paddingHorizontal: 12,
    borderRadius: 14,
  },
  orgDropdownItemHovered: {
    backgroundColor: theme.background.shell,
  },
  orgDropdownIcon: {
    width: 38,
    height: 38,
    borderRadius: 12,
    backgroundColor: theme.primary + '1A',
    alignItems: 'center',
    justifyContent: 'center',
  },
  orgDropdownCopy: {
    flex: 1,
    gap: 2,
  },
  orgDropdownTitle: {
    fontFamily: Platform.OS === 'web' ? '"Space Grotesk", "Inter", system-ui, sans-serif' : undefined,
    fontSize: 15,
    fontWeight: '700',
    color: theme.gray[900],
    letterSpacing: -0.2,
  },
  orgDropdownDescription: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 12.5,
    lineHeight: 17,
    color: theme.gray[600],
  },
  })
}
